import React, {useState, useEffect} from 'react'
import Navbar from '../components/Navbar'
import '../assets/css/dashboard.css'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faPlusCircle, faSignInAlt, faSignOutAlt, faSpinner
} from '@fortawesome/free-solid-svg-icons'
import { getUser } from '../utils/profile';
import bcard from '../assets/images/bcard.png'
import { Beneficiary, Greet } from '../components/DashboardComponent'
import { Display } from '../components/TransactionComponent'
import DepositToWallets from '../components/modals/DepositToWallets'
import WithdrawFromWallets from '../components/modals/WithdrawFromWallets'
import BalanceStatement from '../components/modals/BalanceStatement'

const Wallets = () => {
    const history = useHistory()
    if (!sessionStorage.getItem('idToken')) {
        history.push('/signin')
    }

    const [profile, setProfile] = useState(null)
    const [, setIsPending] = useState(false)
    const [, setError] = useState(null)

    const [fromCoin, setFromCoin] = useState('Binance')
    const [amount, setAmount] = useState(1)
    const [toCoin, setToCoin] = useState('Coinbase')
    const convertedAmt = parseFloat(amount) - 0.5

    useEffect(() => {
        document.title = 'Pouch | Wallets'
        const fetchUser = async () => {
            setIsPending(true)
            let user = await getUser(sessionStorage.getItem('localId'))
            console.log(user)
            if (!user) {
              setError('Could not fetch user data')
            } else {
              if(user.code === 400) {
                setError(user.message || 'Could not fetch user data')
              } else {
                setProfile(user)
              }
            }
        }
        fetchUser()
        setIsPending(false)
        console.log(profile)
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <Navbar />
            {profile ? <div className="container">
                {/* Wallets hero */}
                <div className="row mx-1 my-3">
                    <Greet/>
                </div>
                <div className="row d-flex justify-content-around text-white">
                    <div className="col-md mx-4 p-3 dash-card bg-1 h6 display-6">
                        <Display title="Total Balance" amount={profile.balance.integerValue}/>
                    </div>
                </div>

                <hr className="bg-purple-shade" />

                {/* Wallet and quick transfer */}
                <div className="row p-3 d-flex justify-content-around">
                    <div className="col-md-6 mx-1 my-3 p-2 shadow">
                        <div className="m-0">
                            <button className="float-right mx-1 btn btn-primary" type="button" data-toggle="modal" data-target="#modalWithdrawFromWallets">
                                <FontAwesomeIcon icon={faSignOutAlt} /> Withdraw
                            </button>
                            <button className="float-right mx-1 btn btn-success" type="button" data-toggle="modal" data-target="#modalDepositToWallets">
                                <FontAwesomeIcon icon={faSignInAlt} /> Deposit
                            </button>
                            <h3 className="py-1">Wallets</h3>
                        </div>
                        <hr />
                        <div className="w-100 mt-4">
                            <div className="text-muted m-1 p-4 contactSlide" style={{maxWidth: '100%', overflowY: 'auto', whiteSpace : 'nowrap'}}>             
                                <button className="btn btn-dotted shadow text-center mx-2" type="button" data-toggle="modal" data-target="#modalAddWallet"> 
                                    <p className="m-0"><FontAwesomeIcon icon={faPlusCircle} className="h3 text-primary" /></p>
                                    <p className="m-0 text-muted"> New</p>
                                    <p className="m-0 text-muted">Wallet</p>
                                </button>
                                {[1, 2, 3, 4, 5].map(ele =>{
                                    return <Beneficiary 
                                        key={ele}
                                        imgUrl={bcard}
                                        name="Binance"
                                        name2="$200.1" />
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5 mx-1 my-3 p-2 shadow">
                        <h6>Quick Transfer</h6>
                        <hr />
                        <form action="">
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="">From</label>
                                        <select className="form-control"  onChange={e=> {setFromCoin(e.target.value)}}>
                                        {['Coinbase', 'Lunno', 'Binance'].map((ele, idx) =><option key={idx} value={ele} >{ele}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="">To</label>
                                        <select className="form-control" onChange={e => {setToCoin(e.target.value)}}>
                                            {['Coinbase', 'Lunno', 'Binance'].map((ele, idx) =><option key={idx} value={ele} >{ele}</option>)}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="">Withdrawing Amount</label>
                                        <div className="input-group">
                                            <input className="form-control" placeholder="Amount..." defaultValue="1" onChange={(e) => {parseFloat(setAmount(e.target.value))}} />
                                            <div className="input-group-append">
                                                <div className="input-group-text">{fromCoin}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-md-12 col-lg-6">
                                    <div className="form-group">
                                        <label htmlFor="">Receiving Amount</label>
                                        <div className="input-group">
                                            <input className="form-control" value={convertedAmt.toString()} />
                                            <div className="input-group-append">
                                                <div className="input-group-text">{toCoin}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button className="btn btn-purple btn-block" onClick={e => {e.preventDefault()}}>
                                <FontAwesomeIcon icon={faSignOutAlt} /><span>Transfer Now</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div> :
                <p className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh'}}>                    
                    <FontAwesomeIcon icon={faSpinner} spin className="h3 display-4" />
                </p>
            }
            <DepositToWallets />
            <WithdrawFromWallets />
            <BalanceStatement />
        </>
    )
}

export default Wallets